import { useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import isEqual from 'lodash/isEqual';

import { initialState } from 'state/allSlices';

export const useInitialState = () => {
  const state = useSelector((state) => state, shallowEqual);
  const hasStateInitialValue = isEqual(initialState, state);

  return useMemo(() => ({ hasStateInitialValue }), [hasStateInitialValue]);
};
